<template>
  <div class="bg-light p-3">
    <form action="#" @submit.prevent="validaFormContacto" class="px-3">
      <div class="row mb-3 ">
        <label for="cnombre" class="col-sm-2 col-form-label">Nombre</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" id="cnombre" placeholder="Pedro Perez">
        </div>
      </div>
      <div class="row mb-3">
        <label for="cemail" class="col-sm-2 col-form-label">Email</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" id="cemail" placeholder="correo@ejemplo.com">
        </div>
      </div>
      <div class="row mb-3">
        <label for="cempresa" class="col-sm-2 col-form-label">Empresa</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" id="cempresa" placeholder="Empresa">
        </div>
      </div>
      <div class="row mb-3">
        <label for="ctelefono" class="col-sm-2 col-form-label">Teléfono</label>
        <div class="col-sm-10">
          <input type="number" class="form-control" id="ctelefono" placeholder="0123456789">
        </div>
      </div>
      <div class="row mb-3">
        <label for="ctipodesc" class="col-sm-4 form-label">Probar producto</label>
        <div class="col-sm-8">
          <select id="ctipodesc" class="form-select" v-model="seleccionado" @change="cambiaSeleccion">
          <option v-for="option in opcionesSelect" :selected="option.id == seleccionado" 
                  :value="option.id" :key="option.id">{{option.value}}</option>
        </select>
        </div>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-success fw-bold">Enviar</button>
      </div>
    </form>      
  </div>
</template> 

<script>
export default {
    name: 'FormDescarga',
    data(){
        return {
            opcionesSelect: [{id:1,value:'Sait ERP'},{id:2,value:'Sait Básico'},{id:3,value:'Sait Nómina'},
            {id:4, value:'Tienda en linea Sait'}, {id:5,value:'Telefonia IP'}, {id:6,value:'Respaldos Nube'}],
            seleccionado: this.seleccion,
        }
    },
    props: {
      seleccion: {type: Number, required: true}
    },
    methods: {
        cambiaSeleccion(event){
            this.seleccionado = event.target.value;
        },
        validaFormContacto(){
            this.$emit('verFormDescarga');
            //validacion
            //procesar
            //redirigir
        }
    }
}
</script>
<style scoped>
.wForm{
  position: fixed;
  width: 30rem;
  z-index: 100;
  top: 35vh;
  left: calc(50vw - 15rem);
}
</style>